import React from "react";
import { Box } from "@chakra-ui/react";
import { kebabToCapital } from "utils";
import {
  PaypalLogo,
  DinersClubLogo,
  WalletIcon,
  MasterCardLogo,
  AmexLogo,
  VisaLogo,
  DiscoverLogo,
  MaestroLogo,
  JCBLogo,
  CUPLogo,
  GenericBankLogo,
  SkrillLogo,
} from "components/Logos";

const iconNameToSvgMap = {
  paypal: <PaypalLogo />,
  "diners-club": <DinersClubLogo />,
  wallet: <WalletIcon />,
  "master-card": <MasterCardLogo />,
  "american-express": <AmexLogo />,
  visa: <VisaLogo />,
  electron: <VisaLogo />,
  discover: <DiscoverLogo />,
  maestro: <MaestroLogo />,
  jcb: <JCBLogo />,
  "china-unionpay": <CUPLogo />,
  skrill: <SkrillLogo />,
};

const MethodClassIcon = ({ name }) => {
  const MethodClassIcon = iconNameToSvgMap[name] || <GenericBankLogo />;
  return <Box>{MethodClassIcon || <span>{kebabToCapital(name)}</span>}</Box>;
};

export default MethodClassIcon;
